import { FC, forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { useMethods } from '@lhb/hook';
import styles from './index.module.less';
import { Modal } from 'antd';
import Container from 'src/common/components/Container/index';
// import Analyzing from './Analyzing';
import Result from './Result';

/**
 * 预测报告
 * @description
 * @demo
 */
const Component:FC<{
  /** 重新预测 */
  reload?: () => void;
  /** 预测完成回调 */
  complete?: (data: any) => void;
  ref?: any,
}> = forwardRef(({ reload, complete }, ref) => {

  useImperativeHandle(ref, () => ({
    init: methods.init,
    show: methods.show,
  }));

  /* state */
  const [open, setOpen] = useState(false);

  const containerRef = useRef<any>(null);

  /* hooks */

  /* methods */
  const methods = useMethods({

    /** 初始化报告，从分析中开始 */
    init() {
      methods.show();
    },

    /** 显示报告 */
    show() {
      setOpen(true);
      setTimeout(() => {
        methods.initContainerScrollTop();
      }, 0);

      setTimeout(() => {
        complete?.({ id: 123, predictEntryRate: '1.97%', predictEntryRateTag: '低于平均值请谨慎推进' });
      }, 0);
    },

    initContainerScrollTop() {
      containerRef.current?.scrollTop(0);
    },

    handleCancel() {
      setOpen(false);
      methods.initContainerScrollTop();
    },

    reload() {
      methods.handleCancel();
      reload?.();
    },

  });

  return (<Modal
    open={open}
    maskClosable={false}
    keyboard={false}
    // title='AI进店率预测'
    // onOk={handleOk}
    onCancel={methods.handleCancel}
    width='100vw'
    style={{ top: 0 }}
    footer={null}
    className={styles.predictReportModal}
  >
    <Container ref={containerRef} className={styles.predictReportWrapper}>
      <div className={styles.predictReport}>
        {/* 预测分析中 */}
        {/* <Analyzing /> */}

        {/* 分析完成结果 */}
        <Result reload={methods.reload} />
      </div>
    </Container>
  </Modal>);
});

export default Component;
